module.exports = __webpack_public_path__ + "img/ic_share_tel.5ea90345.svg";